export interface IXmTrackingCenterCounts {
    requestedBy: number,
    requestedFrom: number,
    history: number,
    all: number,
    missingFinalXm: number
}